import { FC, createContext, useState } from 'react';

import { IServerTariff } from 'types/tariff';

import { ITariffContext } from './interfaces';

export const TariffContext = createContext<ITariffContext>({
  tariff: { title: 'default' } as IServerTariff,
  actions: {
    setCurrentTariff: () => null,
  },
});

export const TariffHOC: FC = ({ children }) => {
  const [currentTariff, setCurrentTariff] = useState<IServerTariff | null>();

  return (
    <TariffContext.Provider
      value={{
        tariff: currentTariff ?? null,
        actions: { setCurrentTariff },
      }}
    >
      {children}
    </TariffContext.Provider>
  );
};
